jQuery(function($) {
    // Cache for AJAX responses
    const responseCache = {};
    
    // Track current request to prevent race conditions
    let currentRequest = null;
    
    // Create a container for current and new content if it doesn't exist
    if (!$('#blog-posts-crossfade-container').length) {
        $('#blog-posts-container').wrap('<div id="blog-posts-crossfade-container"></div>');
    }
    
    // Category filtering with elegant transitions
    $('.category-filter').on('click', function(e) {
        e.preventDefault();
        
        // Don't do anything if this category is already active
        if ($(this).parent().hasClass('active')) {
            return false;
        }
        
        const category = $(this).data('category');
        const cacheKey = 'category_' + (category || 'all');
        
        // Update active class immediately for better UX
        $('.blog-block__category').removeClass('active');
        $(this).parent().addClass('active');
        
        // Get container dimensions before making changes
        const containerHeight = $('#blog-posts-container').outerHeight();
        
        // Fix container height only to prevent layout shifts
        $('#blog-posts-crossfade-container').css({
            'height': containerHeight + 'px',
            'position': 'relative',
            'overflow': 'hidden'
        });
        
        // Abort any pending request to prevent race conditions
        if (currentRequest) {
            currentRequest.abort();
        }
        
        // Simple fade out of current content
        $('#blog-posts-container').fadeOut(300);
        
        // Show subtle loading indicator
        if (!$('.blog-elegant-loader').length) {
            $('#blog-posts-crossfade-container').append(
                '<div class="blog-elegant-loader"></div>'
            );
        }
        
        // Check cache first
        if (responseCache[cacheKey]) {
            console.log('Loading from cache for: ' + category);
            
            // Short delay for visual consistency
            setTimeout(function() {
                handleContentUpdate(responseCache[cacheKey].html, responseCache[cacheKey].pagination);
            }, 300);
            
            return false;
        }
        
        // AJAX request
        currentRequest = $.ajax({
            url: blog_vars.ajaxurl,
            type: 'POST',
            data: {
                action: 'simple_filter_blog',
                category: category,
                nonce: blog_vars.blog_filter_nonce
            },
            success: function(response) {
                if (response.success) {
                    // Store in cache
                    responseCache[cacheKey] = {
                        html: response.data.html,
                        pagination: response.data.pagination
                    };
                    
                    // Handle content update
                    handleContentUpdate(response.data.html, response.data.pagination);
                } else {
                    // Handle error
                    handleContentUpdate('<div class="col-12 text-center"><p>Error loading posts</p></div>', '');
                }
                currentRequest = null;
            },
            error: function(xhr, status, error) {
                // Don't show error if it was an abort
                if (status !== 'abort') {
                    handleContentUpdate('<div class="col-12 text-center"><p>Error loading posts: ' + error + '</p></div>', '');
                }
                currentRequest = null;
            }
        });
        
        return false;
    });
    
    // Handle content update with elegant transitions
    function handleContentUpdate(newContent, newPagination) {
        // Create the new content container but keep it hidden
        const $newContainer = $('<div id="new-blog-posts-container" class="row" style="opacity:0;"></div>');
        $newContainer.html(newContent);
        
        // Add to DOM to start loading images
        $('#blog-posts-crossfade-container').append($newContainer);
        
        // Give time for DOM insertion and image loading
        setTimeout(function() {
            // Update pagination
            $('.blog-block__pagination').html(newPagination);
            
            // Remove old container
            $('#blog-posts-container').remove();
            
            // Make new container visible with elegant fade in
            $newContainer.attr('id', 'blog-posts-container').css({
                'transition': 'opacity 400ms ease',
                'opacity': 1
            });
            
            // Remove the loading indicator
            $('.blog-elegant-loader').fadeOut(300, function() {
                $(this).remove();
            });
            
            // Reset container height gradually
            setTimeout(function() {
                $('#blog-posts-crossfade-container').css({
                    'transition': 'height 400ms ease',
                    'height': $('#blog-posts-container').outerHeight() + 'px'
                });
                
                // Return to auto height after transition
                setTimeout(function() {
                    $('#blog-posts-crossfade-container').css({
                        'height': 'auto',
                        'transition': 'none'
                    });
                }, 400);
            }, 100);
        }, 300);
    }
    
    // Handle pagination with the same elegant transition
    $(document).on('click', '.blog-block__pagination a', function(e) {
        e.preventDefault();
        
        // Get page number from URL
        let pageUrl = $(this).attr('href');
        let pageNum = 1;
        
        // Extract page number from URL
        const matches = pageUrl.match(/page\/(\d+)/) || pageUrl.match(/paged=(\d+)/);
        if (matches && matches.length > 1) {
            pageNum = parseInt(matches[1]);
        }
        
        // Get current active category
        const activeCategory = $('.blog-block__category.active .category-filter').data('category') || '';
        const cacheKey = 'category_' + (activeCategory || 'all') + '_page_' + pageNum;
        
        // Get container dimensions before making changes
        const containerHeight = $('#blog-posts-container').outerHeight();
        
        // Fix container height to prevent layout shifts
        $('#blog-posts-crossfade-container').css({
            'height': containerHeight + 'px',
            'position': 'relative',
            'overflow': 'hidden'
        });
        
        // Abort any pending request to prevent race conditions
        if (currentRequest) {
            currentRequest.abort();
        }
        
        // Fade out current content
        $('#blog-posts-container').fadeOut(300);
        
        // Show subtle loading indicator
        if (!$('.blog-elegant-loader').length) {
            $('#blog-posts-crossfade-container').append(
                '<div class="blog-elegant-loader"></div>'
            );
        }
        
        // Check cache first
        if (responseCache[cacheKey]) {
            console.log('Loading from cache for: ' + cacheKey);
            
            // Short delay for visual consistency
            setTimeout(function() {
                handleContentUpdate(responseCache[cacheKey].html, responseCache[cacheKey].pagination);
            }, 300);
            
            return false;
        }
        
        // AJAX request for pagination
        currentRequest = $.ajax({
            url: blog_vars.ajaxurl,
            type: 'POST',
            data: {
                action: 'simple_filter_blog',
                category: activeCategory,
                page: pageNum,
                nonce: blog_vars.blog_filter_nonce
            },
            success: function(response) {
                if (response.success) {
                    // Store in cache
                    responseCache[cacheKey] = {
                        html: response.data.html,
                        pagination: response.data.pagination
                    };
                    
                    // Update content with the same transition
                    handleContentUpdate(response.data.html, response.data.pagination);
                } else {
                    // Handle error
                    handleContentUpdate('<div class="col-12 text-center"><p>Error loading posts</p></div>', '');
                }
                currentRequest = null;
            },
            error: function(xhr, status, error) {
                // Don't show error if it was an abort
                if (status !== 'abort') {
                    handleContentUpdate('<div class="col-12 text-center"><p>Error loading posts: ' + error + '</p></div>', '');
                }
                currentRequest = null;
            }
        });
        
        return false;
    });
});